const mapping = {
  "Text": commentModule,
  "Video": videoModule,
  "Image": imageModule,
  "Trigger": triggerModule,
  "Download": downloadFileModule,
  "Multiple Choice": multiChoiceModule,
  "Fill In The Blank": fillInTheBlankModule,
}

function triggerModule() {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    question: "",
    answers: [{ name: "answer_1", value: "" }],
    created_at: currentDate,
    updated_at: currentDate,
    trigger_email: "",
    lesson_module_name: "LessonTriggerModule",
  }
}

function videoModule() {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    video_url: "",
    created_at: currentDate,
    updated_at: currentDate,
    lesson_module_name: "LessonVideoModule",
  }
}

function fillInTheBlankModule() {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    question: "",
    created_at: currentDate,
    updated_at: currentDate,
    lesson_module_name: "LessonFillInTheBlankModule",
  }
}

function downloadFileModule() {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    created_at: currentDate,
    updated_at: currentDate,
    lesson_module_name: "LessonDownloadFileModule",
  }
}

function multiChoiceModule() {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    question: "",
    answers: [{ name: "answer_1", value: "" }],
    created_at: currentDate,
    updated_at: currentDate,
    lesson_module_name: "LessonMultipleChoiceQuestionModule"
  }
}

function commentModule()  {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    created_at: currentDate,
    updated_at: currentDate,
    text_content: "",
    lesson_module_name: "LessonCommentModule",
  }
}

function imageModule()  {
  const currentDate = new Date().toLocaleDateString("en-US");
  return {
    created_at: currentDate,
    updated_at: currentDate,
    image: "",
    lesson_module_name: "LessonImageModule",
  }
}

export function getWidgetToAdd(name) {
  return mapping[name];
}
